import api from './api';
const PRODUCT_KEY = process.env.REACT_APP_PRODUCT_KEY;

export const updateAccountOnboardingStep = async (accountId, step) => {
  await api.patch(`/accounts/${accountId}`, { onboarding_step: step, product_key: PRODUCT_KEY });
};

export const updateAccountStartProfiles = async (accountId, {
  startProfilesCount,
  language,
  couponCode,
}) => {
  return await api.patch(`/accounts/${accountId}`, {
    start_profiles_count: startProfilesCount,
    language,
    coupon_code: couponCode,
    product_key: PRODUCT_KEY,
  });
};

export const updateAccountOnboardingGoals = async (accountId, goals) => {
  return await api.patch(`/accounts/${accountId}`, {
    onboarding_goals: goals,
    accepted_onboarding_at: new Date(),
    product_key: PRODUCT_KEY,
  });
};

export const updateAccountOnboardingWhatsapp = async (accountId, { phoneCode, phoneNumber }) => {
  return await api.patch(`/accounts/${accountId}`, {
    phone_code: phoneCode,
    phone_number: phoneNumber,
    phone_receive_whatsapp: true,
    product_key: PRODUCT_KEY,
  });
};
